import { jsx as _jsx } from "react/jsx-runtime";
import { UserNotificationSettings } from 'legacy/FVAdminPanel/TenantConfig/views/UserNotificationSettings';
import { useUserContext } from 'xen/providers';
import { ConfigurationsWrapper } from '../components/configurations-wrapper';
const Notifications = () => {
    const { id } = useUserContext();
    return (_jsx(ConfigurationsWrapper, { activeTab: "notifications", children: _jsx(UserNotificationSettings, { user_id: id }) }));
};
export default Notifications;
